import React, { useState, useEffect } from "react";
import { BASE_URL } from "../../../constants";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { Row, Col, Container, Card, Button, InputGroup } from "react-bootstrap";
import "../../../CommonCSS/SocietyCSS.css";

const Add_Leaves_Remuniration = () => {

  const [isEditable, setIsEditable] = useState(false);

  // HEADER STATE
  const [headerData, setHeaderData] = useState({});
  const [Empid, setEmpid] = useState('');
  const [acadFromDate, setacadFromDate] = useState('');
  const [acadToDate, setacadToDate] = useState('');

  const [cbPfNo, setCbPfNo] = useState('');
  const [cbPtNo, setCbPtNo] = useState('');
  const [cbTaxNo, setCbTaxNo] = useState('');



  const [pfNo, setPfNo] = useState('');
  const [ptNo, setPtNo] = useState('');
  const [panNo, setPanNo] = useState('');
  const [pfAmount, setPfAmount] = useState('');
  const [ptAmount, setPtAmount] = useState('');
  const [taxAmount, setTaxAmount] = useState('');

  


  // TABLE 1 STATE
  const [childRemRows, setChildRemRows] = useState([
    {
      emp_id: '',
      from_date: '',
      to_date: '',
      earn_id: '',
      amt: '',
    },
  ]);

  // TABLE 2 STATE
  const [childLeaveRows, setChildLeaveRows] = useState([
    {
      emp_id: '',
      from_date: '',
      to_date: '',
      leave_id: '',
      leaves_allocated: '',
      leaves_availed: '',
      balance_leaves: '',
      leaves_lapsed: '',
      salary_leaves: '',
      leaves_cf: '',

    },
  ]);

  // HEADER CHANGE
  const handleHeaderChange = (e) => {
    const { name, value } = e.target;
    setHeaderData((prev) => ({ ...prev, [name]: value }));
  };

  // ChildRemRows CHANGE
  const handleChildChange1 = (index, e) => {
    const { name, value } = e.target;
    const rows = [...childRemRows];
    rows[index][name] = value;
    setChildRemRows(rows);
  };

  // ChildLeaveRows CHANGE
  const handleChildChange2 = (index, e) => {
    const { name, value } = e.target;
    const rows = [...setChildLeaveRows];
    rows[index][name] = value;
    setChildLeaveRows(rows);
  };

  // ADD ROW
  const addRow1 = () => {
    setChildRemRows([...childRemRows, { holiday_name: "", amount: "" }]);
  };

  const addRow2 = () => {
    setChildLeaveRows([
      ...childLeaveRows,
      { holiday_name: "", from_date: "", to_date: "", applicable: 0 },
    ]);
  };

  // REMOVE ROW
  const removeRow1 = (index) => {
    const rows = [...childRemRows];
    rows.splice(index, 1);
    setChildRemRows(rows);
  };

  const removeRow2 = (index) => {
    const rows = [...setChildRemRows];
    rows.splice(index, 1);
    setChildLeaveRows(rows);
  };

  // NEW
  // const handleNew = () => {
  //   setIsEditable(true);

  //   setHeaderData({
  //     holiday_id: "",
  //     hs_id: "",
  //     catg_code: "",
  //     year1: "",
  //     year2: "",
  //     weekly_off1: "",
  //     weekly_off2: "",
  //   });

  //   setChildRows1([{ holiday_name: "", amount: "" }]);

  //   setChildRows2([
  //     { holiday_name: "", from_date: "", to_date: "", applicable: 0 },
  //   ]);
  // };

  // CLEAR
  const handleClear = () => {
    if (window.confirm("Clear all data?")) {
      setIsEditable(false);
      // handleNew();
    }
  };

  // Proceed
  const handleProceed = () => {
    setIsEditable(true);
    // if (window.confirm("Clear all data?")) {
    //   setIsEditable(false);
    //   handleNew();
    // }
  };

  // SAVE
  const handleSave = () => {
    // console.log("Header:", headerData);
    // console.log("Table1:", ChildRemRows);
    // console.log("Table2:", setChildRemRows);
    alert("Saved (Demo)");
  };

  return (
    <Container fluid className="p-3">
      <h6 style={{ color: '#0044fd' }}><u>Employee and Academic Period</u></h6>
      {/* HEADER */}
      <Card className="mb-4 p-3">

        <Row className="mb-3">
          <Col md={6}>
            <InputGroup>
              <InputGroup.Text style={{ width: "100px" }}>
                Employee
              </InputGroup.Text>
              <select
                className="form-select"
                name="Empid"
                value={Empid}
                disabled={!isEditable}
                onChange={(e) => setEmpid(e.target.value)}
              >
                <option value="">-- Select Employee--</option>
              </select>
            </InputGroup>
          </Col>

          <Col md={5}>
            <InputGroup>
              <InputGroup.Text>Academic Period</InputGroup.Text>
              <input
              type="date"
                className="form-control"
                name="acadFromDate"
                value={acadFromDate}
                onChange={(e) => setacadFromDate(e.target.value)}
                disabled={!isEditable}
              /> &nbsp;
              <input
              type="date"
                className="form-control"
                name="acadToDate"
                value={acadToDate}
                onChange={(e) => setacadToDate(e.target.value)}
                disabled={!isEditable}
              />
            </InputGroup>
          </Col>

          {/* <Col md={3}>
              <input
              type="date"
                className="form-control"
                name="year2"
                value={headerData.year2}
                onChange={handleHeaderChange}
                disabled={!isEditable}
              />
          </Col> */}
        </Row>

        <div className="d-flex justify-content-end gap-2">

          <Button
            style={{ width: "135px", backgroundColor: "#0004f5", borderColor: "#28A745" }}
            onClick={handleProceed}
          >
            Proceed
          </Button>


          {/* <Button style={{ width: "135px" }} onClick={handleNew} disabled={isEditable}>
            New
          </Button> */}

          <Button style={{ width: "135px" }} variant="secondary" onClick={handleClear}>
            Clear
          </Button>

          <Button style={{ width: "135px" }} variant="success" onClick={handleSave} disabled={!isEditable}>
            Save
          </Button>
        </div>

      </Card>

      {/* TABLE 1 */}
      <Card className="p-3 mb-3">
        <div style={{ minHeight: '220px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">
        <h6 style={{ color: 'green' }}><u>Earning Components</u></h6>
        

        <table className="responsive-table scty-custom-table">
          <thead>

            <tr>
               <th style={{ width: '4%', textAlign: 'left' }}>#</th>
                <th style={{ width: '60%', textAlign: 'left' }}>Component</th>
                <th style={{ width: '20%', textAlign: 'right' }}>Amount</th>
                <th style={{ width: '%', textAlign: 'center' }}></th>
               
            </tr>
          </thead>

          <tbody>
            {childRemRows.map((row, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>
                    <select className="form-select" disabled={!isEditable}
                      name="earn_id" value={row.earn_id} onChange={(e) => handleChildChange1(index, e)}>
                      <option value="0">-- Select Component --</option>
                    </select>
                  </td>
                 <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      type="number" className="form-control" name="amt" value={row.amt} onChange={(e) => handleChildChange1(index, e)} />
                  </td>

                <td>
                  {childRemRows.length > 1 && (
                    <Button
                      size="sm"
                      variant="danger"
                      onClick={() => removeRow1(index)}
                    >
                      Delete
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <Button
          className="mt-2"
          style={{ width: "150px" }}
          onClick={addRow1}
          disabled={!isEditable}
        >
          Add Row
        </Button>
        </table>
        </div>
      </Card>

      <Card className="p-3">
        
        <h6 style={{ color: 'red' }}><u>Statutory Deductions</u></h6>


        <Row className="mb-3">
          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "250px" }}>
                Provident Fund(PF) Applicable
              </InputGroup.Text>

              <InputGroup.Text style={{ width: "40px", justifyContent: "center" }}>
                <input
                  type="checkbox"
                  name="cbPfNo"
                  checked={cbPfNo.catg_code || false}
                  onChange={(e) =>
                    setCbPfNo(prev => ({
                      ...prev,
                      catg_code: e.target.checked
                    }))
                  }
                  disabled={!isEditable}
                />
              </InputGroup.Text>
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text>PF No.</InputGroup.Text>
              <input
                className="form-control"
                name="pfNo"
                value={pfNo}
                onChange={(e) => setPfNo(e.target.value)}
                disabled={!isEditable}
              />
            </InputGroup>
          </Col>
          <Col md={3}>
            <InputGroup>
              <InputGroup.Text>	PF Amount</InputGroup.Text>
              <input
                className="form-control"
                name="pfAmount"
                value={pfAmount}
                onChange={(e) => setPfAmount(e.target.value)}
                disabled={!isEditable}
              />
            </InputGroup>
          </Col>
          </Row>

    <Row className="mb-3">

          <Col md={4}>
            <InputGroup>
              <InputGroup.Text>Professional Tax(PT) Applicable</InputGroup.Text>
              <InputGroup.Text>
                <input
                  type="checkbox"
                  name="cbPtNo"
                  checked={cbPtNo.catg_code || false}
                  onChange={(e) =>
                    setCbPtNo(prev => ({
                      ...prev,
                      catg_code: e.target.checked
                    }))
                  }
                  disabled={!isEditable}
                />
              </InputGroup.Text>
            </InputGroup>
          </Col>
          <Col md={3}>
            <InputGroup>
              <InputGroup.Text>	PT No.</InputGroup.Text>
              <input
                className="form-control"
                name="ptNo"
                value={ptNo}
                onChange={(e) => setPtNo(e.target.value)}
                disabled={!isEditable}
              />
            </InputGroup>
          </Col>
           <Col md={3}>
            <InputGroup>
              <InputGroup.Text>	PT Amount</InputGroup.Text>
              <input
                className="form-control"
                name="ptAmount"
                value={ptAmount}
                onChange={(e) => setPtAmount(e.target.value)}
                disabled={!isEditable}
              />
            </InputGroup>
          </Col>
          </Row>

          <Row className="mb-3">

          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "250px" }}>
                Income Tax Applicable
              </InputGroup.Text>

              <InputGroup.Text style={{ width: "40px", justifyContent: "center" }}>
                <input
                  type="checkbox"
                  name="cbTaxNo"
                  checked={cbTaxNo.catg_code || false}
                  onChange={(e) =>
                    setCbTaxNo(prev => ({
                      ...prev,
                      catg_code: e.target.checked
                    }))
                  }
                  disabled={!isEditable}
                />
              </InputGroup.Text>
            </InputGroup>
          </Col>


          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "75px" }}>
                PAN
              </InputGroup.Text>

              <input
                // style={{ width: "300px" }}
                className="form-control"
                name="panNo"
                value={panNo}
                onChange={(e) => setPanNo(e.target.value)}
                disabled={!isEditable}
              />
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text>	Tax Amount</InputGroup.Text>
              <input
                className="form-control"
                name="taxAmount"
                value={taxAmount}
                onChange={(e) => setTaxAmount(e.target.value)}
                disabled={!isEditable}
              />
            </InputGroup>
          </Col>
        </Row>
      </Card> 

           
       {/* TABLE 2 */}
      <Card className="p-3">
         <div style={{ minHeight: '220px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">
        <h6 style={{ color: '#660d32' }}><u>Leaves</u></h6>


        <table className="responsive-table scty-custom-table">
          <thead>
            <th style={{ width: '4%', textAlign: 'left' }}>#</th>
            <th style={{ width: '60%', textAlign: 'left' }}>Leaves</th>
            <th style={{ width: '20%', textAlign: 'right' }}>No. of Leaves</th>
            <th style={{ width: '%', textAlign: 'center' }}></th>

          </thead>

          <tbody>
            {childLeaveRows.map((row, index) => (
              <tr key={index}>
                <td>{index + 1}</td>

                <td>
                    <select className="form-select" disabled={!isEditable}
                      name="sub_type_id" value={row.sub_type_id} onChange={(e) => handleChildChange1(index, e)}>
                      <option value="0">-- Select Leaves --</option>
                    </select>
                  </td>
                 <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      type="text" className="form-control" name="amount" value={row.amount} onChange={(e) => handleChildChange1(index, e)} />
                  </td>

                <td>
                  {childRemRows.length > 1 && (
                    <Button
                      size="sm"
                      variant="danger"
                      onClick={() => removeRow2(index)}
                    >
                      Delete
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <Button
          className="mt-2"
          style={{ width: "150px" }}
          onClick={addRow1}
          disabled={!isEditable}
        >
          Add Row
        </Button>
        
        </table>
        </div>
      </Card>
    </Container>
  );
};

export default Add_Leaves_Remuniration;
